import { Injectable } from '@nestjs/common';
import * as fs from 'fs';
import * as xlsx from 'xlsx'; // npm install xlsx
import { Repository, getManager } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import { CommonResponse, EmployeeCodeRequest, VendorBankColumns, VendorBanksModelDto, VendorBanksResponseModel } from '@gtpl/shared-models/masters';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { employeeWeekOfUploads } from './employee-week-off-uploads.entity';
import { employeeWeekOfUploadsLog } from './employee-week-off-uploads-log.entity';
import { EmployeeWeekOffUploadsColumns } from 'libs/shared-models/hrms/src/lib/employee-week-off-uploads/employee-week-off-uploads-column';
import { EmployeeWeekOffUploadsResponseModel } from 'libs/shared-models/hrms/src/lib/employee-week-off-uploads/employee-week-off-uploads-response-model';
import appSettings from 'apps/services/config';
import { EmployeeWeekOffUploadsDto } from 'libs/shared-models/hrms/src/lib/employee-week-off-uploads/employee-week-off-uploads-dto';


@Injectable()
export class EmployeeWeekOffUploadsService {
    constructor(
        @InjectRepository(employeeWeekOfUploads)
        private employeeWeekoffUploadsRepository: Repository<employeeWeekOfUploads>
    ) { }

    async EmployeeWeekOffUploadsExcel(formData: any): Promise<EmployeeWeekOffUploadsResponseModel> {
        console.log(formData, 'oooooooser');
        const transactionManager = new GenericTransactionManager();
        try {
            await transactionManager.startTransaction();
            const flag = new Set<boolean>();
            const columnArray = [];
            const updatedArray = formData.data.map((obj) => {
                const updatedObj = {};
                for (const key in obj) {
                    const newKey = key
                        .replace(/\s/g, '')
                        .replace(/[\(\)\.]/g, '')
                        .replace(/-/g, '');
                    if (newKey != '') {
                        columnArray.push(newKey);
                        updatedObj[newKey] = obj[key];
                    }
                }
                return updatedObj;
            });
            const difference = columnArray.filter(
                (element) => !EmployeeWeekOffUploadsColumns.includes(element)
            );
            console.log(difference, '----');
            if (difference.length > 0) {
                await transactionManager.releaseTransaction();
                return new EmployeeWeekOffUploadsResponseModel(
                    false,
                    1110,
                    "Excel columns doesn't match. Please attach the correct file."
                );
            }
            const convertedData = updatedArray.map((obj) => {
                const updatedObj = {};
                for (const key in obj) {
                    const value = obj[key];
                    if (value === '') {
                        updatedObj[key] = null;
                    } else {
                        updatedObj[key] = value;
                    }
                }
                return updatedObj;
            });
            // const deleteData = await transactionManager.getRepository(vendorBanksEntity).delete({})
            // if (deleteData) {
            //     flag.add(true)
            // } else {
            //     flag.add(false)
            //     return new EmployeeWeekOffUploadsResponseModel(false, 0, 'Something wwent wrong in data deletion')
            // }
            for (const data of convertedData) {
                // let dtoData
                if (data.EmployeeCode != null) {
                    const existedData = await this.employeeWeekoffUploadsRepository.findOne({
                        where: {

                            employeeCode: data.EmployeeCode,
                        },
                    });
                    if (existedData) {
                        const update = await transactionManager.getRepository(employeeWeekOfUploads)
                            .update({ weekOffId: existedData.weekOffId }, { employeeCode: data.EmployeeCode, weekOffDay: data.WeekOfDay, updatedUser: existedData.createdUser });
                        if (!update.affected) {
                            flag.add(false);
                            await transactionManager.releaseTransaction();
                            return new CommonResponse(
                                false,
                                0,
                                'Something went wrong in updating existing record'
                            );
                        } else {
                            const logs = new employeeWeekOfUploadsLog();
                            logs.employeeId = existedData.employeeId
                            logs.employeeCode = existedData.employeeCode;
                            logs.employeeType = existedData.employeeType;
                            logs.employeeCategory = existedData.employeeCategory;
                            logs.weekOffDay = existedData.weekOffDay
                            logs.weekOffIdLogId = existedData.weekOffId;
                            const addupdatedData = await transactionManager
                                .getRepository(employeeWeekOfUploadsLog)
                                .save(logs);
                            if (addupdatedData) {
                                flag.add(true);
                            } else {
                                flag.add(false);
                                await transactionManager.releaseTransaction();
                                break;
                            }
                        }
                    } else {
                        const manager = getManager()
                        const getDataEmployeeDetails = `SELECT employee_id , emp_category FROM ${appSettings.masters_db}.employee_details WHERE employee_code = '${data.EmployeeCode}'`;
                        const result = await manager.query(getDataEmployeeDetails);
                        console.log(result, 'resultresultresultresultresult')
                        const addObj = new employeeWeekOfUploads();
                        addObj.createdUser = formData.user
                        addObj.employeeId = result[0].employee_id;
                        addObj.employeeCode = data.EmployeeCode;
                        addObj.employeeType = data.EmployeeType
                        addObj.employeeCategory = result[0].emp_category
                        addObj.weekOffDay = data.WeekOfDay
                        const addSave = await transactionManager
                            .getRepository(employeeWeekOfUploads)
                            .save(addObj);
                        if (addSave) {
                            flag.add(true);
                        } else {
                            flag.add(false);
                            await transactionManager.releaseTransaction();
                            return new EmployeeWeekOffUploadsResponseModel(false, 0, 'Somthing went wrong in saving the data');
                        }
                    }
                }
            }
            if (!flag.has(false)) {
                await transactionManager.completeTransaction();
                return new EmployeeWeekOffUploadsResponseModel(true, 1, 'Data saved successfully');
            } else {
                await transactionManager.releaseTransaction();
                return new EmployeeWeekOffUploadsResponseModel(false, 0, 'Something went wrong');
            }
        } catch (err) {
            await transactionManager.releaseTransaction();
            return new EmployeeWeekOffUploadsResponseModel(false, 0, 'Something went wrong');
        }
    }

    async getEmployeeWeekOffUploads(): Promise<EmployeeWeekOffUploadsResponseModel> {
        try {
            let res = []

            const info = await this.employeeWeekoffUploadsRepository.find();
            if (info.length > 0) {
                for (const data of info) {
                    const manager = getManager();

                    // Fetch employee details using employee code
                    const getDataEmployeeDetails = `SELECT CONCAT(employee_name, ' ', emp_last_name) AS employee_name FROM ${appSettings.masters_db}.employee_details WHERE employee_code = '${data.employeeCode}'`;
                    const employeeDetailsResult = await manager.query(getDataEmployeeDetails);
                    const employeeName = employeeDetailsResult.length > 0 ? employeeDetailsResult[0].employee_name : null;

                    console.log(employeeDetailsResult)


                    res.push(new EmployeeWeekOffUploadsDto(data.weekOffId,
                        data.employeeId,
                        data.employeeCode,
                        data.employeeType,
                        data.employeeCategory,
                        data.weekOffDay,
                        data.updatedAt,
                        data.updatedUser,
                        data.createdAt,
                        data.createdUser,
                        employeeName

                    ))
                }
                return new EmployeeWeekOffUploadsResponseModel(true, 1, 'Data retrieved', res);
            } else {
                return new EmployeeWeekOffUploadsResponseModel(false, 0, 'No data found');
            }
        } catch (err) {
            return new EmployeeWeekOffUploadsResponseModel(false, 0, 'Something went wrong', err);
        }
    }

    async getWeekOffByEmpCode(req: EmployeeCodeRequest): Promise<CommonResponse> {
        try {
            const manager = getManager()
            const query = `SELECT w.employee_code AS employeeCode , w.employee_type AS employeeType,w.week_off_day AS weekOffDay from ` + appSettings.hrms_db + `.employee_week_off_uploads w WHERE w.employee_code = '${req.employeeCode}'`
            const data = await manager.query(query);
            if (data && data.length > 0) {
                return new CommonResponse(true, 1111, 'Data Retrieved', data);
            } else {
                return new CommonResponse(false, 1111, 'No data');
            }
        } catch (err) {
            throw err
        }


    }
}
